// extracted by mini-css-extract-plugin
export default {"head":"NewSitePage_head__ATdRL","title":"NewSitePage_title__wMBtP","org":"NewSitePage_org__R4YfI"};